<template>
  <b-container flex>
    <div style="padding-top: 20px; padding-bottom: 10px"><span
        style="font-weight: bold; font-size: large; padding-top: 20px; padding-bottom: 10px">CO2e Metric Tons Emissions</span>
    </div>
    <b-row style="padding-top: 5px" align-h="center">
      <b-col cols="2" style="padding-right: 2px;">Provider:</b-col>
      <b-col lg="10">
        <b-form-radio-group v-model="calculationType">
          <b-form-radio :style="getRadioStyle(co2CalcTypes)"
                        v-for="option in co2CalcTypes"
                        :key="option"
                        :value="option"
                        name="flavour-3a"
                        size="lg">
            {{ option }}
          </b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row style="padding-top: 5px ">
      <b-col sm="9">Electricity CO2e:</b-col>
      <b-col sm="3">
        <b-form-input v-model="electricityEmissions" readonly min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">

      <b-col sm="9">Natural Gas CO2e:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="naturalGasEmissions" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="9">Propane CO2e:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="propaneEmissions" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="9">Gasoline CO2e:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="gasolineEmissions" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="9">Diesel CO2e:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="dieselEmissions" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="9">Total CO2e:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="totalCO2e" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="9">Total CO2e/Ton:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="totalCO2PerTon" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import Bus from '@/eventBus';
import {roundColumnValueToOneDecimalPlace} from "@/MetricUtils";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "Co2Metrics",
  props: {year: Number, groupId: String},
  data() {
    return {
      myYear: this.year,
      myGroupId: this.groupId,
      tonnageCoefficient: 2204.6
    }
  },
  watch: {
    year: function (newVal, oldVal) {
      this.myYear = newVal;
    },
    groupId: function (newVal, oldVal) {
      this.myGroupId = newVal;
      this.loadCalculationType();
    },
    calculationType: function (newVal, oldVal) {
      this.sendUpdate();
    }
  },
  created() {
    Bus.$on('vineyard-fertilizer-edited', this.fertilizerProductionUpdate);
  },
  beforeDestroy() {
    Bus.$off('vineyard-fertilizer-edited', this.fertilizerProductionUpdate);
  },
  mounted() {
    this.loadCalculationType();
  },
  computed:
      {
        calculationType: {
          get() {
            return this.$store.getters.calculationType;
          },
          set(value) {
            this.$store.commit('calculationType', value);
          }
        },
        ...mapGetters(
            ['electricityEmissions',
              'naturalGasEmissions',
              'propaneEmissions',
              'gasolineEmissions',
              'dieselEmissions',
              'totalCO2PerTon',
              'totalCO2e',
              'calculationTypeId',
              'currentMetricsGroupId',
              'co2CalcTypes'
            ]
        ),
        ...mapState(['solar', 'agMeter1', 'agMeter2',
          'agMeter3', 'vineyardAcreage', 'totalTons']),
      },
  methods: {
    ...mapActions({
      postCalculationType: 'postCalculationType',
      putCalculationType: 'putCalculationType'
    }),
    roundColumnValue: function (value) {
      return roundColumnValueToOneDecimalPlace(value);
    },
    loadCalculationType: function () {
      console.log("Reloading Calculation Type");
      let self = this;
      this.$http.get(`metrics/calculation/type/${self.myGroupId}/${self.myYear}`)
          .then(result => {
            if (result.data && result.data !== "") {
              let vineyardCalculationType = result.data;
              self.calculationType = vineyardCalculationType.calculationType;
              self.$store.commit('calculationTypeId', vineyardCalculationType.id);
            }
          })
          .catch(err => {
            this.handleError(err);
          });
    },
    sendUpdate: function () {
      this.uploadCalculationType();
    },
    uploadCalculationType: function () {
      let self = this;
      let calculationTypeUpload = {
        calculationType: self.calculationType,
        groupId: self.groupId,
        id: self.calculationTypeId,
        year: self.myYear
      };
      let calculationTypeJson = calculationTypeUpload;

      if (self.calculationTypeId === undefined || self.calculationTypeId === null) {
        this.postCalculationType(calculationTypeJson);
      } else {
        this.putCalculationType(calculationTypeJson);
      }
    },
    getRadioStyle: function (optionsList) {
      if (!optionsList) {
        return "font-size: medium";
      }
      return 'font-size: medium; padding-bottom:5px;'
    },
    fertilizerProductionUpdate: function (wineProduction) {
      // No Op because we don't care about this.
      console.log(wineProduction);
    },
    doToast: function (message) {
      this.$toasted.show(message,
          {
            containerClass: 'super-toasty',
            iconPack: 'fontawesome',
            closeOnSwipe: true,
            action: {
              text: 'DISMISS',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            },
            icon: {
              name: 'fa-times-circle',
              after: false,
            }
          })
          .goAway(5000);
    }
  }
}
</script>

<style scoped>

</style>
